import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
        specialPayMerchantObj: {},
        specialPayMerchantList: [],
        customStoreList: []
    },
    mutations: {
        modifySpecialPayMerchantObj(state,{pushObj}){
            // console.log('modifySpecialPayMerchantObj=========',pushObj);
            // 如果传入值的商户id与与原id不同
            if (state.specialPayMerchantObj.merchantId != pushObj.merchantId) {
                state.specialPayMerchantObj = {...pushObj}
            }else{
                // id相同观察内部的doorList
                state.specialPayMerchantObj.doorList = pushObj.doorList
            }
         
        },
        modifySpecialPayMerchantList(state,{pushObj,pushList}){
            if (pushList) { //直接传入整体
                state.specialPayMerchantList = JSON.parse(JSON.stringify(pushList)) 
                return
            }
            if (state.specialPayMerchantList.length) {
              let arr = JSON.parse(JSON.stringify(state.specialPayMerchantList)) 
              let findIndex = arr.findIndex(v=>v.merchantId==pushObj.merchantId)
              if (findIndex>-1) { //同商户
                if (pushObj.doorList.length) {
                    state.specialPayMerchantList[findIndex].doorList = JSON.parse(JSON.stringify(pushObj.doorList)) 
                }else{
                    state.specialPayMerchantList.splice(findIndex,1)
                }
              }else{
                pushObj.doorList.length&&state.specialPayMerchantList.push(pushObj)
              }
            }else{
                pushObj.doorList.length&&state.specialPayMerchantList.push(pushObj)
            }
        },
        setCusList(state,pushList) {
            state.customStoreList = pushList
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js